import { render } from "./InviteCandidate.vue?vue&type=template&id=07c9bcb2"
import script from "./InviteCandidate.vue?vue&type=script&lang=js"
export * from "./InviteCandidate.vue?vue&type=script&lang=js"

import "./InviteCandidate.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__